import { render, staticRenderFns } from "./activityResultForm.vue?vue&type=template&id=4b0095d0"
import script from "./activityResultForm.vue?vue&type=script&lang=js"
export * from "./activityResultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports